"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("./events");
const handlers_1 = require("./handlers");
function handleEvent(event, payload) {
    switch (event) {
        case events_1.events.BUY_TICKET: {
            return handlers_1.handleBuyTicketEvent(payload);
        }
        case events_1.events.VIEW_ITEM: {
            return handlers_1.handleViewItemEvent(payload);
        }
    }
}
exports.handleEvent = handleEvent;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-website-events/src/eventHandler.ts